import { atom } from 'jotai';

export type RenderingsActiveTool = 'ai-rendering' | 'magic-edit';

export const renderingsActiveToolAtom = atom<RenderingsActiveTool>('ai-rendering');
